import React from 'react';
import SubHeader from '../../components/Layout/SubHeader';
import { getAuthToken, storeUserData } from '../../components/Util';
import axios from 'axios';
import api from '../../config/api';
import strings from '../../components/Language';
import { ProgressBar } from 'react-loader-spinner';
import { Button, Spin } from 'antd';
import { toast } from 'react-toastify';

class ReferralScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ProgressBar: true,
            lang: strings.getLanguage(),
            access_token: null,
            data: [],
            next_page_url: null,
            prev_page_url: null,
            refreshing: false,
        }
    }

    async componentDidMount() {
        let self = this;
        var token = await getAuthToken();

        if (token) {
            self.setState({ access_token: token });
            await storeUserData(token, this);
            setTimeout(() => {
                self.getSponsorData();
            });
        }
    }

    getSponsorData() {
        const self = this;
        self.setState({ 'refreshing': true })
        axios({
            method: 'GET',
            url: api.SponsorList + "?lang=" + self.state.lang,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            if (ress.data.error == 200) {
                self.setState({
                    data: (ress.data.message && ress.data.message && ress.data.message.data) ? ress.data.message.data : [],
                    hasMore: (ress.data.message && ress.data.message && ress.data.message.next_page_url) ? true : false,
                    next_page_url: (ress.data.message && ress.data.message && ress.data.message.next_page_url) ? ress.data.message.next_page_url : '',
                    prev_page_url: (ress.data.message && ress.data.message && ress.data.message.prev_page_url) ? ress.data.message.prev_page_url : '',
                })
            }
            self.setState({ refreshing: false })
            self.setState({ ProgressBar: false });
        }).catch(function (erro) {
            self.setState({ 'refreshing': false });
            self.setState({ ProgressBar: false });
        });
    }

    getNextPageData(APIURL) {
        const self = this;
        if (!APIURL) {
            toast.error(strings['Next_link_not_found']);
            return false;
        }
        axios({
            method: 'GET',
            url: APIURL,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            if (ress.data.error == 200) {
                self.setState({
                    data: (ress.data.message && ress.data.message && ress.data.message.data) ? [...self.state.data, ...ress.data.message.data] : self.state.data,
                    hasMore: (ress.data.message && ress.data.message && ress.data.message.next_page_url) ? true : false,
                    next_page_url: (ress.data.message && ress.data.message && ress.data.message.next_page_url) ? ress.data.message.next_page_url : '',
                    prev_page_url: (ress.data.message && ress.data.message && ress.data.message.prev_page_url) ? ress.data.message.prev_page_url : '',
                })
            }
        }).catch(function (erro) {
        });
    }

    render() {
        return (
            <>
                <ProgressBar visible={this.state.ProgressBar} height="80" width="80" color="#f05a29" borderColor='#f05a29' barColor='#f05a29' wrapperClass="progress-bar" />
                <SubHeader data={{ title: strings["referralList"] }} />

                <div className='referralScreen'>
                    <main className="align-box">
                        {this.state.data.map((item, i) =>
                            <div key={"REFERRAL_001_" + i} className="referral-box">
                                <p>{item.user.username}</p>
                                <label>{strings["memberMobile"]} <span>{item.user.mobile}</span> </label>
                            </div>
                        )}
                    </main>
                    <div className='load-more'>
                        {this.state.refreshing && <Spin />}
                        {this.state.hasMore && !this.state.refreshing && (
                            <Button type="submit" id="loginButton" className="load-more-button" loading={this.state.isLoading} onClick={() => this.getNextPageData(this.state.next_page_url ? this.state.next_page_url : '')}>
                                {strings['Load More']}
                            </Button>
                        )}
                        {(!this.state.refreshing && this.state.data && this.state.data.length <= 0) ?
                            <p>{strings["No more data to load"]}</p>
                            : null}
                    </div>
                </div>
            </>
        );
    }
}

export default ReferralScreen;
